module.exports = __webpack_public_path__ + "static/media/banner.40d8515c.jpg";